<ng-container *ngIf="isVisible">
  <axs-tooltip-trigger #trigger id="input-tabs-coachmark-trigger" axs-for="input-tabs-coachmark-tooltip"
    [attr.axs-theta]="theta" axs-allow-focus-within="" class="input-tabs-coachmark__trigger">
    <button #coachmarkTriggerButton aria-hidden="true" tabindex="-1" class="input-tabs-coachmark__trigger-btn"></button>
  </axs-tooltip-trigger>

  <axs-tooltip id="input-tabs-coachmark-tooltip" axs-prevent-outside-dismiss="" class="input-tabs-coachmark__tooltip">
    <axs-coachmark slot="content">
      <axs-coachmark-title axs-disable-auto-title="true" (axs-close-click)="onClose()">
        <p class="text-subtitle-3 input-tabs-coachmark__title" slot="title">{{ coachMarkContent?.header }}</p>
      </axs-coachmark-title>

      <div class="text-body-2 input-tabs-coachmark__description" [innerHTML]="coachMarkContent?.description"></div>
    </axs-coachmark>
  </axs-tooltip>
</ng-container>